import { environment } from '@app-env/environment';
import { SiteKey } from '../core/models';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

const GTM_IDS: Record<SiteKey, string> = {
	'csomag-hu': 'GTM-5Q838VV',
	'ecsomag-hu': 'GTM-TPT3V78',
} as const;
const SITE_CONFIG = environment.SITE_CONFIG as SiteKey;

export const extModules = [
	GoogleTagManagerModule.forRoot({
		id: GTM_IDS[SITE_CONFIG],
	}),
];
